import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

import Usage from './usage';
import Personal from './personal';

import { clearError } from '../../modules/account';

import '../../stylesheets/account.css';

class Account extends Component {
  componentDidMount() {
    const { connectedClearError } = this.props;
    connectedClearError();
  }

  render() {
    return (
      <div className="re is-main">
        <div className="re is-header">
          <Header as="h1" className="re is-header-item">
            Account Information
          </Header>
        </div>
        <div className="account-page-content">
          <Usage />
          <Personal />
        </div>
      </div>
    );
  }
}

Account.propTypes = {
  connectedClearError: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedClearError: clearError,
}, dispatch);

export default connect(
  undefined,
  mapDispatchToProps,
)(Account);
